module.exports = __webpack_public_path__ + "img/christ.7c4cb036.jpg";